import React from 'react';
import { connect } from 'react-redux';

import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { SSelect } from "@avalara/skylab-sdk/react";

const log = new Logger('MONTH_SELECTOR', LOG_LEVELS.DEBUG);

export class MonthSelector extends React.Component {

    selectionHandler(event) {
        log.debug('selectionHandler(): ', event);
        log.debug('selectionHandler(): target.value', event.detail.item.value);
        this.props.selectionHandler({month: event.detail.item.value})
    }

    getMonthSelectorOptions() {
      let optionsList = [{
        label: LANGUAGES_CONTROLLER.format(this.props.languages, this.props.defaultValueLabelKey || 'None'),
        value: ''
      }];
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      monthNames.forEach((val, ind) => {
          optionsList.push({
              label: val,
              value: ind+1+"",
              selected: this.props.month === (ind+1+"")? true: false
          });
      })
      return optionsList;
    }

    render() {
      log.debug('render(): ', this.props);
      const extraProps = this.props.extraProps || {};
      return (
        <SSelect defaultValue={this.props.month} 
            inputId="single-month-select"
            name="month-selector"
            data-testid="month-selector"
            onS-select={this.selectionHandler.bind(this)}
            optionsList={this.getMonthSelectorOptions() || []}
            multiple={false}
            showSelectionCount={false}
            role="combobox"
            disabled={this.props.disabled}
            className={extraProps.className || ""}
        />
      )
    }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


MonthSelector.defaultProps = {
  extraProps: {},
  defaultValueLabelKey: 'None'
}

// Wrap the component to inject state into it
export default connect(mapStateToProps)(MonthSelector);